import React from "react";
import Grid from "@mui/material/Grid";
import CaseDetailsItem from "../../../Common/CaseDetailsItem/CaseDetailsItem";

const SubscriptionSpecificCaseDetails = ({ contractLawCase }: any) => {
  return (
    <Grid container>
      <CaseDetailsItem caseData={contractLawCase} fieldPath={"wasDeceived"} />
      <CaseDetailsItem caseData={contractLawCase} fieldPath={"salesChannel"} />
      <CaseDetailsItem caseData={contractLawCase} fieldPath={"subscriptionName"} />
      <CaseDetailsItem caseData={contractLawCase} fieldPath={"contractNumber"} />
    </Grid>
  );
};

export default SubscriptionSpecificCaseDetails;
